import {
    LIST_DEPENDENCIES,
    LIST_DEPENDENCIES_SUCCESS,
    LIST_DEPENDENCIES_ERROR,
    ADD_DEPENDENCIES,
    SAVE_DEPENDENCIES,
    SAVE_DEPENDENCIES_SUCCESS,
    SAVE_DEPENDENCIES_ERROR,
    EDIT_DEPENDENCIES,
    UPDATE_DEPENDENCIES,
    UPDATE_DEPENDENCIES_SUCCESS,
    UPDATE_DEPENDENCIES_ERROR,
    DELETE_DEPENDENCIES,
    DELETE_DEPENDENCIES_SUCCESS,
    DELETE_DEPENDENCIES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    dependencies: null,
    error: null,
    loading: false,
    dependencySelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_DEPENDENCIES:
            return {
                ...state,
                loading: true
            }
        case LIST_DEPENDENCIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_DEPENDENCIES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                dependencies: action.payload
            }
        case SAVE_DEPENDENCIES:
        case DELETE_DEPENDENCIES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_DEPENDENCIES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_DEPENDENCIES_ERROR:
        case UPDATE_DEPENDENCIES_ERROR:
        case DELETE_DEPENDENCIES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_DEPENDENCIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                dependencies: [...state.dependencies, action.payload]
            }
        case ADD_DEPENDENCIES:
            return {
                ...state,
                dependencySelected: null,
                isEdit: false
            }
        case EDIT_DEPENDENCIES:
            return {
                ...state,
                dependencySelected: action.payload,
                isEdit: true
            }
        case UPDATE_DEPENDENCIES_SUCCESS:
        case DELETE_DEPENDENCIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                dependencies: state.dependencies.map(dependency => 
                    dependency.id === action.payload.id ? dependency = action.payload : dependency
                ),
                dependencySelected: null
            }
        // case DELETE_DEPENDENCIES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         dependencies: state.dependencies.filter( dependency => dependency.id !== action.payload)
        //     }
        default:
            return state;
    }
}